import i18nextSprintfPostProcessor from 'i18next-sprintf-postprocessor';

function sprintf(value, ...args) {
	// convert %1 or %1d to %1$s before regular sprintf processing
	value = value.replace(/(%\d+)(\$\w)?/g, '$1\$s');
	return i18nextSprintfPostProcessor.process(value, value, {
		sprintf: args
	});
}

window.sprintf = sprintf;

export { sprintf };